import React, { useContext } from 'react'
import { useHistory, useParams } from 'react-router-dom';

import Logo from 'components/Gui/Logo';
import PackageInfo from 'components/PackageInfo/PackageInfo';
import { ConfigContext } from 'contexts/ConfigContext';
import { usePackage } from 'contexts/PackageContext';
import { HeaderWrapper } from './NwHeaderUI';
import ShortlistBar from 'components/Shortlist/ShortlistBar';

const NwListHeader = () => {
    const history = useHistory();
    const { code } = useParams();
    const { clientConfig } = useContext(ConfigContext)
    const { header } = clientConfig

    let showPackageInfo = true;
    if (clientConfig && clientConfig.packageInfo && clientConfig.packageInfo.show === false) {
        showPackageInfo = false;
    }

    const { useShortlist } = usePackage();


    const handleMoveToHome = () => {
        if (code) {
            history.push(`/ebook/${code}`);
        } else {
            history.push('/');
        }
    };

    return (
        <HeaderWrapper $useShortlist={useShortlist}>
            <div className="header-left">
                <Logo />
            </div>
            <div className="header-middle">
                {header && header.htmlContent
                    ?
                    <div className="header-html-content" dangerouslySetInnerHTML={{ __html: header.htmlContent }} />
                    :
                    <p></p>
                }
            </div>
            <div className="header-right">
                {code && showPackageInfo &&
                    <PackageInfo onClick={handleMoveToHome} />
                }
                {useShortlist && (
                    <ShortlistBar />
                )}
            </div>
        </HeaderWrapper>
    )
}

export default NwListHeader

